import toggleModal from "../mixins/toggleModal.js";

export default {
	mixins: [toggleModal]
};
